module.exports = ".flexbox-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n}\n\n.width-left-one {\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/helpers/filters/anno-filter/anno-filter.component.css
// module id = ./src/app/helpers/filters/anno-filter/anno-filter.component.css
// module chunks = main